export const FETCH_TAXSETTING_BEGIN="FETCH_TAXSETTING_BEGIN";
export const FETCH_TAXSETTING_SUCCESS="FETCH_TAXSETTING_SUCCESS";
export const FETCH_TAXSETTING_FAILURE="FETCH_TAXSETTING_FAILURE";